import { Svg } from '@repo/ui';

import ErrorBaseView, { ErrorBaseViewController } from '@/components/tax-refund/common/view/ErrorView/ErrorBaseView';

interface Props {
  onPrimaryButtonClick: () => void;
}

const HometaxSessionError = ({ onPrimaryButtonClick }: Props) => {
  const errorBaseViewController: ErrorBaseViewController = {
    graphic: <Svg src="icg_clock_md.svg" width={80} height={80} />,
    title: '홈택스 로그인 유효 시간이 지나\n다시 조회가 필요해요',
    primaryButtonText: '다시 조회',
    onPrimaryButtonClick: onPrimaryButtonClick,
    primaryButtonVariant: 'filled-primary'
  };

  return <ErrorBaseView viewController={errorBaseViewController} />;
};

export default HometaxSessionError;
